import axios from 'axios';
import authHeader from '../auth-header';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";
import tokenHeader from '../token-header';
// const API_URL = 'https://localhost:9090 /api/all/ ';

 
const getKwitansi = 'e-kwitansi';
const postKwitansiUrl = 'e-kwitansi';
const putKwitansi = 'e-kwitansi/';
const deleteKwitansi = 'e-kwitansi/';

class KwitansiService {
    getKwitansi() {
        return axios.get(
            API_URL + getKwitansi,
            {
                headers: authHeader()
            });
    }

    postKwitansi(formData) {
        var headers = authHeader();        
        var form = new FormData();
        form.append("nama", formData.nama);
        if (typeof formData.file !== 'undefined') {
            form.append('file', formData.file);
        }
        form.append("statusUpdateFile", "1");
        form.append("status", "1");
        return axios
            .post(API_URL + postKwitansiUrl, form,{ 
            headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() } 
        })
        .then(response => {
            
            return response.data.message;
        });
    }

    putKwitansi(formData) {
        var headers = authHeader();        
        var form = new FormData();
        form.append("nama", formData.nama);
        if (typeof formData.file !== 'undefined') {
            form.append('file', formData.file);
        }
        form.append("statusUpdateFile", formData.statusUpdateFile);
        form.append("status", formData.status);
        return axios
            .put(API_URL + postKwitansiUrl, form,{ 
            headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() } 
        })
        .then(response => {
            
            return response.data.message;
        });
    }

    putKwitansi(formData) {
        var headers = authHeader(); 
        var form = new FormData();
        form.append("nama", formData.nama);
        if (typeof formData.file !== 'undefined') {
            form.append('file', formData.file);
        }
        form.append("statusUpdateFile", formData.statusUpdateFile);
        form.append("status", formData.status);
        return axios
        .put(
            API_URL + putKwitansi + formData.idKwitansi, form,
            { headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() }  }
        );
    }

    deleteKwitansi(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteKwitansi + formData.idKwitansi,
                { headers: authHeader() }
            );
    }

}

export default new KwitansiService();